import Default from './forms/Default.vue';

/*
* Load the component based on the platform and method.
* This has been deprecated but maybe used in the future for custom forms.
*/
export function loadComponent(platform, method, form) {

    return Default;
}